<template>
  <div>
    <InvoiceViewer ref="invoiceViewer" />

    <v-navigation-drawer
      v-model="open"
      :width="$isMobile ? '100%' : '75%'"
      right
      fixed
      :permanent="open"
      hide-overlay
      class="z-index--100 px-2"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="open" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel()"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6">
          <div class="titlePanel primary--text">
            {{ $t('management.resultReport.otherResultReportsPanel.title') }}
          </div>
        </div>

        <div class="my-4">
          <v-data-table
            :loading-text="table.loadingText"
            :loading="table.loading"
            :headers="table.headers"
            :items="table.data"
            :options="table.options"
            class="tableReport"
          >
            <template v-slot:[`item.paymentDate`]="{ item }">
              <div v-if="getPidDate(item.statusChanges)">
                {{ $moment(getPidDate(item.statusChanges)).format('DD/MM/YYYY') }}
              </div>
            </template>
            <template v-slot:[`item.paymentOrder`]="{ item }">
              <div>{{ item.uuid }}</div>
            </template>
            <template v-slot:[`header.amount`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <div class="text-right">{{ formatCurrency(item.total) }}</div>
            </template>
            <template v-slot:[`item.invoice`]="{ item }">
              <div v-if="!isEmpty(item.invoices)">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      depressed
                      @click="downloadReport(item.invoices[0])"
                      class="blueButton"
                    >
                      <v-icon>mdi-receipt</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('management.resultReport.otherResultReportsPanel.table.viewInvoice') }}</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.invoiceDate`]="{ item }">
              {{ !isEmpty(item.invoices) ? $moment(item.invoices[0].issuedAt).format('DD/MM/YYYY') : 'Sin factura' }}
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <div v-if="!isEmpty(item.invoices)">
                {{ item.invoices[0].uuid }}
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div>{{ item.status }}</div>
            </template>
            <template v-slot:[`item.accountStatus`]="{ item }">
              <div>{{ getAccountStatus(item) }}</div>
            </template>

            <!-- <template v-slot:footer="">
              <Pagination
                :itemsPerPage="table.options.itemsPerPage"
                :page="table.options.page"
                :total="totalRecords"
              />
            </template> -->
          </v-data-table>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

import InvoiceViewer from '@/components/modals/InvoiceViewer'
// import Pagination from '@/components/elements/Pagination'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'OtherResultReportsPanel',
  components: {
    // Pagination,
    InvoiceViewer
  },
  props: {
    selectedDates: Array
  },
  data () {
    return {
      open: false,
      table: {
        loadingText: this.$i18n.t('management.resultReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.invoiceDate'), value: 'invoiceDate', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.paymentOrder'), value: 'paymentOrder', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.amount'), value: 'amount', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.invoice'), value: 'invoice', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.paymentDate'), value: 'paymentDate', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.id'), value: 'id', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('management.resultReport.otherResultReportsPanel.table.headers.accountStatus'), value: 'accountStatus', sortable: false }
        ],
        data: [
          // Todo: delete testing
          { _id: 1, paymentDate: '2022-10-11', paymentOrder: 'orden 1', amount: 1.6, invoice: {}, invoiceDate: '2022-10-10', id: 4214242151, status: 'paid', accountStatus: 'active' },
          { _id: 2, paymentDate: '2022-10-11', paymentOrder: 'orden 1', amount: 1.6, invoice: {}, invoiceDate: '2022-10-10', id: 4214242151, status: 'paid', accountStatus: 'active' },
          { _id: 3, paymentDate: '2022-10-11', paymentOrder: 'orden 1', amount: 1.6, invoice: {}, invoiceDate: '2022-10-10', id: 4214242151, status: 'paid', accountStatus: 'active' },
          { _id: 4, paymentDate: '2022-10-11', paymentOrder: 'orden 1', amount: 1.6, invoice: {}, invoiceDate: '2022-10-10', id: 4214242151, status: 'paid', accountStatus: 'active' },
          { _id: 5, paymentDate: '2022-10-11', paymentOrder: 'orden 1', amount: 1.6, invoice: {}, invoiceDate: '2022-10-10', id: 4214242151, status: 'paid', accountStatus: 'active' }
        ],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  watch: {
    open: function (val) {
      if (val) {
        this.loadReports()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.open = false
    },
    getPidDate (statusChanges) {
      return statusChanges.find(status => status.name === 'paid')
    },
    getAccountStatus (item) {
      if (item.status === 'paid' && !isEmpty(item.invoices)) {
        return 'OK'
      }
      return 'EXTEMPORANEA'
    },
    openPanel () {
      this.open = true
    },
    closePanel () {
      this.open = false
    },
    formatCurrency,
    async downloadReport (item) {
      // let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${id}/download-invoice-pdf`
      // url += `?access_token=${this.$store.state.login.token}`

      // return url
      if (item) {
        await this.$refs.invoiceViewer.open(item)
      }
    },
    // Todo: integrate api
    loadReports: async function () {
      if (this.selectedDates.length === 2) {
        const [startDate, endDate] = this.selectedDates
        const params = {
          'createdAt>': startDate,
          'createdAt<': endDate
        }
        const restauratId = this.$store.state.currentRestaurant.data._id
        this.table.loading = true
        try {
          const response = await this.$api.get(`/v1/reports/${restauratId}/accounting/expense-detail`, params)
          // const {
          //   payOrdersReceived,
          //   paidOrders,
          //   pendingPaymentOrders,
          //   ordersWithOutSupport,
          //   outgoingCategories
          // } = response
          // let dataItems = []
          // dataItems.push({
          //   expense: this.$i18n.t('management.expensesReport.table.expenses.payOrdersReceived'),
          //   ...payOrdersReceived
          // })
          // dataItems.push({
          //   expense: this.$i18n.t('management.expensesReport.table.expenses.paidOrders'),
          //   ...paidOrders
          // })
          // dataItems.push({
          //   expense: this.$i18n.t('management.expensesReport.table.expenses.pendingPaymentOrders'),
          //   ...pendingPaymentOrders
          // })
          // dataItems.push({
          //   expense: this.$i18n.t('management.expensesReport.table.expenses.ordersWithoutSupport'),
          //   ...ordersWithOutSupport
          // })
          // outgoingCategories.forEach(({ name, ...rest }) => dataItems.push({ expense: name, ...rest }))
          // this.table.data = dataItems
          this.table.data = response.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.loading = false
      }
    },
    isEmpty
  }
}
</script>

<style lang="scss" scoped>
  .tableReport {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>
